import React from 'react'
import DashboardLayout from "../../layouts/DashboardLayout"
import { Route, Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router';

const CalendarView = React.lazy(() => import("../../CalendarView"))
const MapView = React.lazy(() => import("../../MapView"))
const ControlPanelView = React.lazy(() => import("../../ControlPanelView"))
const WeatherView = React.lazy(() => import("../../WeatherView"))

const RegionView = React.lazy(() => import('./region/RegionView'))
const BuildingView = React.lazy(() => import('./building/BuildingView'))
const PostView = React.lazy(() => import("./post/PostView"))


const EnergyView = () => {

    const {path} = useRouteMatch()

    // const RegionView = React.lazy(() => import('./region/RegionView'))
    // const BuildingView = React.lazy(() => import('./building/BuildingView'))

    return (
        <DashboardLayout mode={"energy"}>
            <DashboardLayout.TopLeftView>
                <MapView mode={"energy"} />
            </DashboardLayout.TopLeftView>
            <DashboardLayout.BottomLeftView>
                <ControlPanelView mode={"energy"} />
            </DashboardLayout.BottomLeftView>
            <DashboardLayout.TopRightView>
                <WeatherView/>
            </DashboardLayout.TopRightView>
            <DashboardLayout.BottomRightView>
                <CalendarView/>
            </DashboardLayout.BottomRightView>
            <DashboardLayout.MainView>
                <Switch>
                    <Route path={`${path}/building/:buildingCode`}><BuildingView/></Route>
                    <Route path={`${path}/post/:postCode`}><PostView/></Route>
                    <Route path={path}><RegionView/></Route>
                </Switch>
            </DashboardLayout.MainView>
        </DashboardLayout>
    )
}

export default EnergyView